import { useBootcamps } from "../../contexts/bootcamp.context";
import { sanitizeImageUrl } from "../../utils/sanity.utils";
import { memo } from "react";
import Link from "next/link";

interface PropsType {
  value: {
    reference: {
      _ref: string;
    };
  };
}

export const InternalLink = memo<PropsType>((props: PropsType) => {
  const { _ref } = props.value.reference;

  const { bootcamps, commonTranslates } = useBootcamps();
  const bootcamp = bootcamps.find((b) => b._id === _ref);
  if (!bootcamp) {
    return null;
  }

  return (
    <Link href={`/bootcamp/${bootcamp.slug}`}>
      <div className="lg:grid grid-cols-3 pb-15">
        <div className="lg:absolute bottom-[150px] right-[60px] lg:right-[0px] xl:right-[60px] lg:max-w-[280px] xl:max-w-[330px] col-span-1 bg-day-base-base-100 rounded-[20px] p-6 flex flex-col">
          <div className="mb-12">
            <img
              src={sanitizeImageUrl(bootcamp.image.asset._ref)}
              alt="Article image"
              loading="lazy"
              className="rounded-[20px]"
            />
          </div>
          <div className="pl-4 pr-4">
            <div className="uppercase lg:text-[20px] leading-[124%] text-day-base-base-900">
              <span className="text-day-base-base-400">
                {commonTranslates.bootcampTitle}:{" "}
              </span>
              <span
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: bootcamp.title,
                }}
              ></span>
            </div>
            <div
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: bootcamp.intro,
              }}
              className="pt-4 pb-12 text-day-base-base-400 text-[16px] leading-[124%]"
            ></div>
          </div>
          <span className="flex items-center justify-center bg-day-blue-ive text-white rounded-[14px] pt-5 pb-5 pl-10 pr-10 h-[48px] lg:h-[56px] lg:pb-8 lg:pt-8 lg:pr-16 lg:pl-16">
            <span className="lg:relative top-[1px]">
              {commonTranslates.moreInfoTitle}
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
});
